import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
// @dynamic
@Injectable()
export class ShellDomainProvider {
    private platformIdValue: string;
    public static api: any;
    constructor( @Inject(PLATFORM_ID) platformId: string) {
        this.platformIdValue = platformId;
        if (this.platformIdValue === 'browser') {
            ShellDomainProvider['api'] =  window['shellDomain'];
            if (window['mockData']) {
              ShellDomainProvider['mockData'] =  window['mockData'];
            }
        } else {
            ShellDomainProvider['api'] = JSON.parse(process.env['shellDomain']);
            if (process.env['mockData']) {
              ShellDomainProvider['mockData'] = JSON.parse(process.env['mockData']);
            }
        }
    }
}
